export const MBOX_GROUP_TITLE = 'M-Box usage'
export const MASTER_DELIVERY_GROUP_TITLE = 'Master delivery'
export const STORAGE_GROUP_TITLE = 'Storage (TB)'
export const PROXY_REGENERATION_TITLE = 'Proxy regeneration'
